import { api } from '@services';
import Tag, { ITag, ITagApiModel } from '@models/Tag.model';

interface ICombineTag {
  tagsIds: string[];
  tagCategoryId: string;
  name: string;
}

const combineTags = async (data: ICombineTag): Promise<ITag> => {
  const { data: tag } = await api.post<ITagApiModel>('/tags/combine', data);
  return Tag.fromApiModel(tag);
};

export { combineTags };
